// extracted by mini-css-extract-plugin
export var desc = "levels-module--desc--f048d";
export var levels = "levels-module--levels--3efe5";
export var levels__button_active = "levels-module--levels__button_active--2a809";
export var levels__button_hidden = "levels-module--levels__button_hidden--f533a";
export var levels__buttons = "levels-module--levels__buttons--6d1ac";
export var levels__info = "levels-module--levels__info--5460b";
export var levels__info_abilities = "levels-module--levels__info_abilities--dc165";
export var levels__info_materials = "levels-module--levels__info_materials--2ac26";
export var levels__tabPanel = "levels-module--levels__tab-panel--1c20f";
export var levels__text = "levels-module--levels__text--167c1";
export var levels__title = "levels-module--levels__title--79cee";
export var levels__wrapper = "levels-module--levels__wrapper--fe747";
export var num = "levels-module--num--52e18";